import {React} from 'common'
import ButtonNavigate from 'components/Page/Login/ButtonNavigate'
import LoginBasic from 'components/Page/Login/LoginBasic'
import useForgotPassword from 'logic/Login/useForgotPassword'
import useResetPassword from 'logic/Login/useResetPassword'
import {useParams} from 'react-router-dom'

const i18nCategory = 'forgotPassword'
const ForgotPassword = () => {
    const {token} = useParams()
    return (
        <LoginBasic
            i18nCategory={i18nCategory}
            useAction={token ? useResetPassword : useForgotPassword}>
            {!token && <ButtonNavigate i18nCategory={i18nCategory} path="/login" />}
        </LoginBasic>
    )
}

export default ForgotPassword
